import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconHub20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconHub20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.75 3.798a1.499 1.499 0 1 0-1.5 0v2.529a3.73 3.73 0 0 0-2.003 1.13L5 6.16a1.498 1.498 0 0 0-2.795-.66 1.5 1.5 0 0 0 2.122 2.003l2.14 1.236a3.76 3.76 0 0 0-.049 2.374l-2.245 1.296A1.498 1.498 0 0 0 2.206 14.5 1.5 1.5 0 0 0 5 13.664l2.142-1.237a3.75 3.75 0 0 0 2.107 1.247v2.528a1.499 1.499 0 1 0 1.5 0v-2.529a3.74 3.74 0 0 0 2-1.125l2.249 1.299a1.498 1.498 0 0 0 2.795.653 1.5 1.5 0 0 0-2.127-2l-2.138-1.234a3.75 3.75 0 0 0 .053-2.374l2.249-1.298A1.498 1.498 0 0 0 17.794 5.5a1.5 1.5 0 0 0-2.795.842L12.86 7.577a3.75 3.75 0 0 0-2.11-1.25zm-.75 8.45a2.249 2.249 0 1 0 0-4.496 2.249 2.249 0 0 0 0 4.497"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconHub20);
